import {
  ClearButtons,
  FormatButtons,
  LevelSelect,
  LinkButtons,
  ListButtons,
  QuoteButtons,
  RichTextInput,
  RichTextInputToolbar,
} from "ra-input-rich-text";
import * as React from "react";
import {
  ArrayInput,
  Create,
  CreateProps,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";
import ImageCropInput from "../../creatorsShared/imageCrop/ImageCropInput";

const AboutCreate = (props: CreateProps) => {
  const [locale] = useLocaleState();

  return (
    <Create {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <ImageCropInput
          slot="sectionImage"
          fullWidth
          sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
          label={false}
          source="sectionImage"
        />
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="sectionTitle" label="about.title" />

          <TextInput
            fullWidth
            source="sectionSubtitle"
            label="about.subtitle"
          />
          <RichTextInput
            toolbar={
              <RichTextInputToolbar>
                <LevelSelect />
                <FormatButtons />
                <ListButtons />
                <LinkButtons />
                <QuoteButtons />
                <ClearButtons />
              </RichTextInputToolbar>
            }
            fullWidth
            source="sectionDescription"
            label="about.description"
          />

          <ArrayInput label="about.companyInfo" source="companyInfo">
            <SimpleFormIterator fullWidth>
              <TextInput fullWidth source="title" label="about.optionTitle" />
              <TextInput
                fullWidth
                source="description"
                label="about.optionDescription"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SimpleForm>
    </Create>
  );
};

export default AboutCreate;
